import React,{useState,useEffect} from 'react'
import clinicService from '../../../services/clinic.service'
import articlesService from '../../../services/articles.service'
import { useParams } from 'react-router-dom'
import { useEyeconxStore } from '../../../store/eyeconxStore'
import Loading from '../../common/Loading'
import { get } from 'react-hook-form'
function ArticlePrint() {
    const {articleId} = useParams()
    const clinicId = useEyeconxStore(state => state.user.clinicId)
    const [article,setArticle] = useState({})
    const [clinic,setClinic] = useState({})
    const [isloading,setIsLoading] = useState(false)
    const [articleNotFound,setArticleNotFound] = useState(false)
    useEffect(()=>{
        getArticleById()
        getClinicInfo()
        //once loaded open print dialog
        openPrint()

    },[])

    const openPrint = ()=>{
        //open print window after 2 seconds 
        setTimeout(()=>{
            window.print()
        }
        ,2000)
        
    }
    const getArticleById = ()=>{
        setIsLoading(true)
        articlesService.getArticleById(clinicId,articleId)
        .then(res=>{
            setArticle(res.data)
            setIsLoading(false)
        })
        .catch(err=>{
            setIsLoading(false)
            setArticleNotFound(true)
            console.log(err)
        })
    }
    const getClinicInfo = ()=>{
        setIsLoading(true)
        clinicService.getClinicInfo(clinicId)
        .then(res=>{

            setClinic(res.data)
            setIsLoading(false)
        })
        .catch(err=>{
            console.log(err)
            setIsLoading(false)
        })
    }
  return (
    <div className="container container-xxl bg-light-secondary rounded p-3">
        {isloading ? <Loading /> : <>
       
        <div className="d-flex justify-content-center align-items-center mt-3">
            {clinic.logo && <img src={clinic.logo} alt="logo" className="img-fluid w-50" />}  
        </div>
       <div className="container d-print-block mt-4">
            <div className="row">
                <div className="col-12">
                    {article && <>
                        <h1>{article.title}</h1>
                    <div dangerouslySetInnerHTML={{ __html: article.content }} />
                    </>}
                    {articleNotFound && <h1>Article Not Found</h1>}
                   
                </div>
            </div>
       </div>
       </>}
    </div>
  )
}

export default ArticlePrint